<template>
  <div class="cs-aleart d-flex justify-content-around align-items-center" v-if="alert.toggle">
    <div class="content-alert">{{alert.content}}</div>
    <img class="icon-alert" @click="onClose" src="@/assets/images/icon-close.svg" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "CommonNotification",
  computed: {
    ...mapGetters('sub-account', ['alert']),
  },
  props: {
  },
  methods: {
    onClose() {
      this.$store.dispatch('sub-account/setAlert', {
        content: '',
        toggle: false,
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// @import '@/assets/scss/account-info/management.scss';

</style>
